"use client";
import { jsx as x, jsxs as J } from "react/jsx-runtime";
import { useContext as O, createContext as T, useState as N, useCallback as A, useEffect as j, useMemo as Q, memo as q } from "react";
const L = ["light", "dark"], B = "(prefers-color-scheme: dark)", F = typeof window > "u", D = T(void 0), G = {
  setColorMode: (e) => {
  },
  colorModes: []
}, U = () => O(D) ?? G;
function te(e, d) {
  const t = U();
  return (t.forcedColorMode ?? t.resolvedColorMode) === "dark" ? d : e;
}
const oe = (e) => (O(D), /* @__PURE__ */ x(Z, { ...e })), W = () => {
}, X = {
  setColorMode: W,
  colorModes: ["dark"],
  colorMode: "dark",
  forcedColorMode: "dark",
  resolvedColorMode: "dark",
  systemColorMode: "dark"
}, se = ({ children: e }) => /* @__PURE__ */ x(D.Provider, { value: X, children: /* @__PURE__ */ x("div", { "data-theme": "dark", children: e }) }), Y = ["light", "dark"], Z = ({
  forcedColorMode: e,
  disableTransitionOnChange: d = !1,
  enableSystem: t = !1,
  enableColorScheme: v = !0,
  storageKey: a = "inkeep-colorMode",
  colorModes: n = Y,
  defaultColorMode: o = t ? "system" : "light",
  attribute: k = "data-theme",
  value: f,
  children: w,
  nonce: E,
  shadowHostId: y,
  rootId: $
}) => {
  const [c, l] = N(() => P(a, o)), [C, i] = N(() => P(a)), m = f ? Object.values(f) : n, g = A((s) => {
    let r = s;
    if (!r) return;
    s === "system" && t && (r = R());
    const M = f ? f[r] : r, V = d ? H() : null, I = y && $ && document.getElementById(y)?.shadowRoot, S = I ? I.getElementById($) ?? document.documentElement : document.documentElement;
    if (k === "class" ? (S.classList.remove(...m), M && S.classList.add(M)) : M ? S.setAttribute(k, M) : S.removeAttribute(k), v) {
      const _ = L.includes(o) ? o : null, z = L.includes(r) ? r : _;
      S.style.colorScheme = z;
    }
    V?.();
  }, []), u = A(
    (s) => {
      l(s);
      try {
        localStorage.setItem(a, s);
      } catch {
      }
    },
    [e]
  ), h = A(
    (s) => {
      const r = R(s);
      i(r), c === "system" && t && !e && g("system");
    },
    [c, e]
  );
  j(() => {
    const s = window.matchMedia(B);
    return s.addListener(h), h(s), () => s.removeListener(h);
  }, [h]), j(() => {
    const s = (r) => {
      if (r.key !== a)
        return;
      const M = r.newValue || o;
      u(M);
    };
    return window.addEventListener("storage", s), () => window.removeEventListener("storage", s);
  }, [u]), j(() => {
    g(e ?? c);
  }, [e, c]);
  const p = Q(
    () => ({
      colorMode: c,
      setColorMode: u,
      forcedColorMode: e,
      resolvedColorMode: c === "system" ? C : c,
      colorModes: t ? [...n, "system"] : n,
      systemColorMode: t ? C : void 0
    }),
    [c, u, e, C, t, n]
  );
  return /* @__PURE__ */ J(D.Provider, { value: p, children: [
    /* @__PURE__ */ x(
      b,
      {
        forcedColorMode: e,
        disableTransitionOnChange: d,
        enableSystem: t,
        enableColorScheme: v,
        storageKey: a,
        colorModes: n,
        defaultColorMode: o,
        attribute: k,
        value: f,
        children: w,
        attrs: m,
        nonce: E,
        shadowHostId: y,
        rootId: $
      }
    ),
    w
  ] });
}, b = q(
  ({
    forcedColorMode: e,
    storageKey: d,
    attribute: t,
    enableSystem: v,
    enableColorScheme: a,
    defaultColorMode: n,
    value: o,
    attrs: k,
    nonce: f,
    shadowHostId: w,
    rootId: E
  }) => {
    const y = n === "system", $ = (() => {
      const i = w && E ? `document.getElementById('${w}').shadowRoot.getElementById('${E}')` : "document.documentElement";
      if (t === "class") {
        const m = `c.remove(${k.map((g) => `'${g}'`).join(",")})`;
        return `var d=${i},c=d.classList;${m};`;
      }
      return `var d=${i},n='${t}',s='setAttribute';`;
    })(), c = a ? (L.includes(n) ? n : null) ? `if(e==='light'||e==='dark'||!e)d.style.colorScheme=e||'${n}'` : "if(e==='light'||e==='dark')d.style.colorScheme=e" : "", l = (i, m = !1, g = !0) => {
      const u = o ? o[i] : i, h = m ? `${i}|| ''` : `'${u}'`;
      let p = "";
      return a && g && !m && L.includes(i) && (p += `d.style.colorScheme = '${i}';`), t === "class" ? m || u ? p += `c.add(${h})` : p += "null" : u && (p += `d[s](n,${h})`), p;
    }, C = e ? `!function(){${$}${l(e)}}()` : v ? `!function(){try{${$}var e=localStorage.getItem('${d}');if('system'===e||(!e&&${y})){var t='${B}',m=window.matchMedia(t);if(m.media!==t||m.matches){${l(
      "dark"
    )}}else{${l("light")}}}else if(e){${o ? `var x=${JSON.stringify(o)};` : ""}${l(o ? "x[e]" : "e", !0)}}${y ? "" : `else{${l(n, !1, !1)}}`}${c}}catch(e){}}()` : `!function(){try{${$}var e=localStorage.getItem('${d}');if(e){${o ? `var x=${JSON.stringify(o)};` : ""}${l(o ? "x[e]" : "e", !0)}}else{${l(
      n,
      !1,
      !1
    )};}${c}}catch(t){}}();`;
    return /* @__PURE__ */ x("script", { nonce: f, dangerouslySetInnerHTML: { __html: C } });
  },
  // Never re-render this component
  () => !0
), P = (e, d) => {
  if (F) return;
  let t;
  try {
    t = localStorage.getItem(e) || void 0;
  } catch {
  }
  return t || d;
}, H = () => {
  const e = document.createElement("style");
  return e.appendChild(
    document.createTextNode(
      "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}"
    )
  ), document.head.appendChild(e), () => {
    window.getComputedStyle(document.body), setTimeout(() => {
      document.head.removeChild(e);
    }, 1);
  };
}, R = (e) => (e || (e = window.matchMedia(B)), e.matches ? "dark" : "light");
export {
  Z as ColorMode,
  oe as ColorModeProvider,
  se as DarkModeProvider,
  U as useColorMode,
  te as useColorModeValue
};
